import { Skeleton } from './skeleton';

const PageSkeleton = () => {
    return (
        <div className="space-y-6 p-4">
            {/* Header */}
            <Skeleton className="h-8 w-1/4" />

            {/* Card */}
            <div className="space-y-4 rounded-xl border border-gray-200 bg-white p-4">
                <Skeleton className="h-6 w-1/3" />

                <div className="space-y-3">
                    <Skeleton className="h-10 w-full" />
                    <Skeleton className="h-10 w-full" />
                    <Skeleton className="h-20 w-full" />
                </div>

                <div className="flex justify-end">
                    <Skeleton className="h-10 w-24" />
                </div>
            </div>

            {/* Table */}
            <div className="space-y-3 rounded-xl border border-gray-200 bg-white p-4">
                {[...Array(5)].map((_, i) => (
                    <Skeleton key={i} className="h-8 w-full" />
                ))}
            </div>
        </div>
    );
};

export default PageSkeleton;
